export function getTimezone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeZone = props.timezone || props.timeZone || context.timezone || context.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone; // browser's timezone

  /* All the Etc/GMT± timezones will succeed if they are the browser default, but
   * if we pass in the browser default as a string (as in timeZone's defaultProps)
   * then it doesn't pass the validation regex. So we will need to remap these to
   * timezones that have the same offset
   */
  var tzMapping = {
    'Etc/GMT+5': 'America/Cayman',
    // this one isn't strictly necessary, here for example
    'Etc/GMT+7': 'America/Phoenix'
  };
  if (timeZone in tzMapping) {
    timeZone = tzMapping[timeZone];
  }
  try {
    // see if the browser will accept the given timezone
    Intl.DateTimeFormat('en', {
      timeZone: timeZone
    });
  } catch (_unused) {
    // UTC is the only value all browsers must recognize
    timeZone = 'UTC';
  }
  return timeZone;
}
export default getTimezone;